// @ts-nocheck
import { useState, useEffect, useCallback } from 'react'
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import * as z from "zod"
import { Button } from "@/components/ui/button"
import _ from 'lodash';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Switch } from "@/components/ui/switch"
import helpers from '@/utils/helpers';
import { Checkbox } from "@/components/ui/checkbox"

const parseNumberInput = (value: string): number | undefined => {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? undefined : Math.max(0, parsed);
};

const formSchema = z.object({
  admins: z.array(z.string()).default([]),
});

type FormValues = z.infer<typeof formSchema>

type SettingsType = {
  admins?: string[];
}

interface AdminPermissionList {
  onSubmitSuccess: (values: SettingsType) => void
  data: any,
  adminList: any
}

export function AdminPermissionList({ onSubmitSuccess, data, adminList = [] }: AdminPermissionList) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      // `admins` is entity-level now (was previously `config.admins`).
      // Fall back to the old location for any callers still on the old shape.
      admins: _.get(data, 'admins', _.get(data, 'config.admins', []))
    }
  })

  async function onSubmit(values: FormValues) {
    setIsSubmitting(true)
    try {
      await new Promise(resolve => setTimeout(resolve, 500)) // Simulating API call
      let payload : SettingsType = {};
      payload.admins = values.admins;

      onSubmitSuccess(payload)
    } catch (error) {
      console.error('Failed to submit form:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="admins"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Assign Admins</FormLabel>
              <div className="space-y-2">
                {_.map(adminList, (admin: any) => (
                  <div key={admin._id} className="flex items-center space-x-2">
                    <Checkbox
                      checked={_.includes(field.value, admin._id)}
                      onCheckedChange={(checked: boolean) => {
                        const updatedValue = checked
                          ? [...(_.map(field.value) || []), admin._id]
                          : (_.map(field.value) || []).filter((id: string) => id !== admin._id);
                        field.onChange(updatedValue);
                      }}
                    />
                    <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                      {admin.name || admin.email}
                    </label>
                  </div>
                ))}
              </div>
              <FormDescription>
                Select administrators for this team.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button 
          type="submit" 
          className="w-full" 
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Save Changes"}
        </Button>
      </form>
    </Form>
  )
}

